import React from 'react';
import { Box, Stack } from '@mui/material';
import { useAssessmentsKeysQuery, useAssessmentSubmissionsQuery } from '@uplift/queries';
import { AssessmentKeys, getAssessmentFormMaxScore } from '@uplift/types';
import { Loader, SmallProgressChart } from '@uplift/ui-v2';
import { CalendarDateService } from '@uplift/services';
import { FormsChipFilter, SourceChipFilter, SourceChipFilterValue } from './ChipFilters';


const TrendsChart: React.VFC<{ patientId: string; assessmentKey: AssessmentKeys; assessmentFormId: string; filter?: SourceChipFilterValue }> = (props) => {
  const { data: _submissions } = useAssessmentSubmissionsQuery(props.patientId, props.assessmentKey);
  const { data: assessmentKeys } = useAssessmentsKeysQuery();
  const now = React.useMemo(() => CalendarDateService.date(), []);
  const chartData = _submissions?.map(submission => ({
    datetime: CalendarDateService.date(submission.submission.createdAt),
    score: submission.score,
    scoreDiffPercentage: submission.scoreDiffPercentage,
  })) ?? [];
  const maxScore = React.useMemo(() => getAssessmentFormMaxScore(props.assessmentFormId, assessmentKeys), [ props.assessmentFormId, assessmentKeys ]);

  return (
    <Box sx={{ height: 300 }}>
      <SmallProgressChart
        data={chartData}
        fillUpTo={now}
        maxScore={maxScore}
      />
    </Box>
  );
};


export const TrendsTab: React.VFC<{ patientId: string }> = (props) => {
  const { data: assessmentKeys } = useAssessmentsKeysQuery();
  const [ assessmentKey, setAssessmentKey ] = React.useState(Object.keys(assessmentKeys)[0]);
  const [ completedByFilter, setCompletedByFilter ] = React.useState<SourceChipFilterValue>();

  return (
    <Stack gap={1} sx={{ p: 2 }}>
      <FormsChipFilter value={assessmentKey} setValue={setAssessmentKey} />
      <SourceChipFilter value={completedByFilter} setValue={setCompletedByFilter} />

      <React.Suspense fallback={<Loader height="300px" color="primary" />}>
        <TrendsChart
          patientId={props.patientId}
          assessmentKey={assessmentKey as AssessmentKeys}
          assessmentFormId={assessmentKeys[assessmentKey]}
          filter={completedByFilter}
        />
      </React.Suspense>
    </Stack>
  );
};
